<div class="panel">
  <div class="panel__header">
    <span class="panel__header__title">{{ header }}</span>
  </div>
  <div class="panel__content">
    <ng-content></ng-content>
  </div>
</div>
